import React, { FC } from 'react';


const Footer: FC = (): JSX.Element => {
  return (

    <div className='footer-container'>
      <p>Copyright © 2017 ZotaPay Inc. All rights reserved.</p>
      <p>Ux Design & Creative: Sefi Bogin</p>
    </div>
  )
}


export default Footer;